import React, { Component } from "react";
import ClientProfile from "../../../containers/Clients/editClientProfile";
import BusinessUnits from "../../../containers/Clients/editBusinessUnits";
import ClientTeamMembers from "../../../containers/Clients/TeamMembers";
import EmployeeUserStatus from "../../../containers/Employees/user-status";

import BusinessUnitsDetail from "../../../containers/Clients/editBusinessUnitsDetail";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import TeamMemberDetail from "../../../containers/Clients/editTeamMemberDetail";
import { NavLink, Route, Redirect, Switch } from "react-router-dom";
import qs from "qs";

import { isEmpty } from "lodash";
// css
import "./edit-client-profile.css";

class Index extends Component {
  getUrlParams() {
    let urlArrayLike = this.props.location.pathname.split("/");
    if (/cid/g.test(this.props.location.search)) {
      return this.props.location.search.split("=")[1];
    } else if (urlArrayLike.length >= 6) {
      if (isNaN(+this.props.location.pathname.split("/")[5])) {
        return this.props.location.pathname.split("/")[6];
      } else {
        return this.props.location.pathname.split("/")[5];
      }
    } else {
      return this.props.location.pathname.split("/")[4];
    }
  }
  showRouteBread(ifShowName = false) {
    const urlLinkArray = this.props.location.pathname.split("/");
    const roleName = JSON.parse(localStorage.getItem("session")).roleName;
    if (urlLinkArray.length >= 4 && !ifShowName) {
      if (
        /^(administrator|team member)/gi.test(roleName) &&
        urlLinkArray[3] === "Client-Profile"
      ) {
        return "Business Unit Information";
      } else {
        if (
          /^(administrator|team member)/gi.test(roleName) &&
          urlLinkArray[3] === "Client-Team-Members"
        ) {
          return "Business Unit Team Members";
        } else {
          return urlLinkArray[3].split("-").join(" ");
        }
      }
    }
  }

  controlBreadStyle() {
    if (
      /^(\/clients\/edit\/Business-Units\/)[0-9]{1,}$/g.test(
        this.props.location.pathname,
      )
    ) {
      return "0 13%";
    } else if (
      /^\/clients\/edit\/Business-Units\/detail\/\d/g.test(
        this.props.location.pathname,
      )
    ) {
      return "0 13%";
    } else if (
      /^\/clients\/edit\/Client-Team-Members/g.test(
        this.props.location.pathname,
      )
    ) {
      return "";
    } else if (
      /^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(
        this.props.location.pathname,
      )
    ) {
      return "0 10%";
    } else if (
      /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Member/g.test(
        this.props.location.pathname,
      )
    ) {
      return "0 10%";
    }
  }

  showDetailRouter(text) {
    let regText = `/clients/edit/${text}/user-status`;
    let regDetailText = `/clients/edit/${text}/detail`;
    let regTx = `/clients/edit/${text}`;
    let reg = new RegExp(regText, "g");
    let regT = new RegExp(regTx, "g");
    if (new RegExp(regDetailText, "g").test(this.props.location.pathname)) {
      return (
        <li key="li-detail">
          <a href={`/clients/edit/${text}/${this.getUrlParams()}`}>
            {this.showRouteBread()}
          </a>
        </li>
      );
    }
    if (reg.test(this.props.location.pathname)) {
      // for system administrator | account manager CLIENT TEAM MEMBERS tab
      if (
        /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(
          this.props.location.pathname,
        ) &&
        /^(system administrator|account manager)/gi.test(
          JSON.parse(localStorage.getItem("session")).roleName,
        )
      ) {
        return [
          <li key="li-clients-list">
            <a
              href={`/clients/edit/${text}/${
                qs.parse(this.props.location.search.split("?")[1]).cid
              }?name=${localStorage.getItem("clientTeamMemberName")}`}
            >
              {this.showRouteBread()}
            </a>
          </li>,
          <li key="li-pre-us"> > </li>,
          <li key="li-user-status">
            {localStorage.getItem("clientTeamMemberName")}
          </li>,
        ];
      } else if (
        /^\/clients\/edit\/Client-Team-Members\/user-status/g.test(
          this.props.location.pathname,
        ) &&
        /^(administrator|team member)/gi.test(
          JSON.parse(localStorage.getItem("session")).roleName,
        )
      ) {
        return [
          <li key="li-clients-list">
            <a
              href={`/clients/edit/${text}/${
                qs.parse(this.props.location.search.split("?")[1]).cid
              }?name=${
                qs.parse(this.props.location.search.split("?")[1]).name
              }`}
            >
              {this.showRouteBread()}
            </a>
          </li>,
          <li key="li-pre-us"> > </li>,
          <li key="li-user-status">
            {localStorage.getItem("clientTeamMemberName")}
          </li>,
        ];
      } else {
        return [
          <li key="li-clients-list">
            <a
              href={`/clients/edit/${text}/${this.props.location.search.replace(
                "?cid=",
                "",
              )}`}
            >
              {this.showRouteBread()}
            </a>
          </li>,
          <li key="li-pre-us"> > </li>,
          <li key="li-user-status">User Status</li>,
        ];
      }
    } else if (regT.test(this.props.location.pathname)) {
      return (
        <li key={"li-" + this.props.location.pathname}>
          {this.showRouteBread()}
        </li>
      );
    }
  }
  showChildCrumb() {
    if (
      !/^\/clients\/edit\/Client-Team-Members\/user-status/g.test(
        this.props.location.pathname,
      )
    ) {
      if (
        /^\/clients\/edit\/(Business-Units|Client-Team-Members)\/detail\/\d/g.test(
          this.props.location.pathname,
        )
      ) {
        return <li>{this.props.location.pathname.split("/")[6]}</li>;
      } else {
        const id = this.props.location.pathname.split("/")[6];
        const query = qs.parse(this.props.location.search.split("?")[1]);
        if (
          /^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(
            this.props.location.pathname,
          )
        ) {
          return (
            <li>
              <a
                href={`/clients/edit/Business-Units/detail/Team Members/${id}?name=${
                  qs.parse(this.props.location.search.split("?")[1])
                    .businessUnitName
                }&id=${query.id}`}
              >
                Business Unit Team Members
              </a>
            </li>
          );
        } else if (
          /^\/clients\/edit\/Business-Units\/detail\/Team Members/g.test(
            this.props.location.pathname,
          )
        ) {
          return <li>Business Unit Team Members</li>;
        } else {
          return <li>{this.props.location.pathname.split("/")[5]}</li>;
        }
      }
    }
  }
  render() {
    if (!isEmpty(this.props.location.search)) {
      this.props.location.search.replace("?cid=", "");
    }
    const roleName = JSON.parse(localStorage.getItem("session")).roleName;
    return (
      <MuiThemeProvider>
        <div className="edit-profile">
          <ul
            className="edit-profile-curmb"
            style={{
              padding: this.controlBreadStyle(),
            }}
          >
            <li>
              <a href="/clients">
                {/^(account manager|system administrator)/gi.test(roleName)
                  ? "Clients"
                  : "Business Units"}
              </a>
            </li>
            <li>{">"}</li>
            {this.showDetailRouter("Client-Profile")}
            {this.showDetailRouter("Business-Units")}
            {this.showDetailRouter("Client-Team-Members")}
            {/*for business-units detail*/}
            {/^\/clients\/edit\/(Business-Units|Client-Team-Members)\/detail/g.test(
              this.props.location.pathname,
            ) && <li style={{ margin: "0 0.4em" }}>></li>}
            {this.showChildCrumb()}
            {/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(
              this.props.location.pathname,
            ) && <li style={{ margin: "0 0.4em" }}>></li>}
            {/^\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(
              this.props.location.pathname,
            ) && (
              <li>{qs.parse(this.props.location.search.split("?")[1]).name}</li>
            )}
          </ul>
          <nav>
            <ul>
              <li
                className={
                  /^\/clients\/edit\/Client-Profile/g.test(
                    this.props.location.pathname,
                  )
                    ? "active"
                    : ""
                }
              >
                <NavLink
                  activeClassName="editActive"
                  to={`/clients/edit/Client-Profile/${this.getUrlParams()}?name=${
                    qs.parse(this.props.location.search.split("?")[1]).name
                  }`}
                >
                  {/^(account manager|system administrator)/gi.test(roleName)
                    ? "Client"
                    : "Business Unit"}{" "}
                  Profile
                </NavLink>
              </li>
              {this.props.edit_client_profile &&
                this.props.edit_client_profile.subscriptionTierId !== 5 && (
                  <li
                    className={
                      /^\/clients\/edit\/Client-Team-Members/g.test(
                        this.props.location.pathname,
                      )
                        ? "active"
                        : ""
                    }
                  >
                    <NavLink
                      activeClassName="editActive"
                      to={`/clients/edit/Client-Team-Members/${JSON.parse(
                        localStorage.getItem("editClientId"),
                      )}?name=${
                        qs.parse(this.props.location.search.split("?")[1]).name
                      }`}
                    >
                      {/^(account manager|system administrator)/gi.test(
                        roleName,
                      )
                        ? "Client"
                        : "Business Unit"}{" "}
                      Team Members
                    </NavLink>
                  </li>
                )}
              {/^(account manager|system administrator)/gi.test(roleName) &&
                this.props.edit_client_profile &&
                this.props.edit_client_profile.subscriptionTierId !== 5 && (
                  <li
                    className={
                      /^\/clients\/edit\/Business-Unit/g.test(
                        this.props.location.pathname,
                      )
                        ? "active"
                        : ""
                    }
                  >
                    <NavLink
                      activeClassName="editActive"
                      to={`/clients/edit/Business-Units/${this.getUrlParams()}`}
                    >
                      Business Units
                    </NavLink>
                  </li>
                )}
            </ul>
          </nav>
          <div />
          <Switch>
            <Redirect
              exact
              from="/clients/edit"
              to="/clients/edit/Client-Profile"
            />
          </Switch>
          <Route
            exact
            path="/clients/edit/Client-Profile/:id"
            component={ClientProfile}
          />
          <Route
            exact
            path="/clients/edit/Business-Units/:id"
            component={BusinessUnits}
          />
          <Route
            exact
            path="/clients/edit/Client-Team-Members/:id"
            component={ClientTeamMembers}
          />
          <Route
            exact
            path="/clients/edit/Client-Team-Members/detail/:id/:name/:memberId"
            component={TeamMemberDetail}
          />
          <Route
            path="/Clients/edit/Client-Team-Members/user-status/:id/:pageNumber/:sortColumn/:order"
            exact
            component={EmployeeUserStatus}
          />

          <Route
            exact
            path="/clients/edit/Business-Units/detail/:id/:name/:businessUnitId"
            component={BusinessUnitsDetail}
          />
          {/*for business units team member*/}
          <Route
            exact
            path="/clients/edit/Business-Units/detail/Team Members/:id"
            component={ClientTeamMembers}
          />
          {/*for business units suspend or reactive*/}
          <Route
            exact
            path="/clients/edit/Business-Units/detail/Business Unit Team Members/:id"
            component={EmployeeUserStatus}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/Clients/EditClientProfile/Index.jsx